import BaseSerializer from './Base';
import {toSize} from 'ol/size';
import XYZ from 'ol/source/XYZ';
import {isDefined} from '@config/utils';

class XYZSerializer extends BaseSerializer {
    constructor() {
        super();
        this.sourceCls = XYZ;
        this.allowedImageExtensions = ['png', 'jpg', 'gif'];
    }

    serialize(layer, source) {
        this.validateSource(source);
        let tileGrid = source.getTileGrid();
        let serialized = {
            baseURL: source.getUrls() ? source.getUrls()[0] : window.location.href.split(/[?#]/)[0].replace(/^\/|\/$/g, ''),
            opacity: layer.getOpacity(),
            imageExtension: this.getImageExtensionFromSource(source)
                || 'png',
            resolutions: tileGrid.getResolutions(),
            tileSize: toSize(tileGrid.getTileSize()),
            type: 'OSM'
        };
        return serialized;
    }

    /**
     * Returns the file extension from the url and compares it to whitelist.
     * Sources with an tileUrlFunction are currently not supported.
     *
     * @private
     * @param {ol.source.XYZ} source An ol.source.XYZ.
     * @return {String} The fileExtension or `false` if none is found.
     */
    getImageExtensionFromSource(source) {
        let urls = source.getUrls();
        let url = urls ? urls[0] : '';
        let extension = url.substr(url.length - 3);

        if (isDefined(url)
            && this.allowedImageExtensions.includes(extension)) {
            return extension;
        } else {
            this.raiseException('No url(s) supplied for ' + source.constructor.name);
            return false;
        }
    }

    validateSource(source) {
        if (!(source instanceof this.sourceCls)) {
            this.raiseException('Cannot serialize this source with this serializer');
        }
        if (source.getUrls() === null) {
            this.raiseException('Cannot serialize this source without an URL. ' +
                'Usage of tileUrlFunction is not yet supported');
        }
    }
};

export default XYZSerializer;